import React from 'react';

export const TopUpCreditCardSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
    >
      <rect
        width={40}
        height={40}
        fill='#FFF7F2'
        rx={20}
      />
      <path
        stroke='#040325'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M27.5 13.333h-15c-.92 0-1.667.746-1.667 1.667v10c0 .92.746 1.667 1.667 1.667h15c.92 0 1.667-.747 1.667-1.667V15c0-.92-.747-1.667-1.667-1.667ZM10.833 18.333h18.334'
      />
    </svg>
  );
};
